import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield, FileText, Info } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './KVKK.css';

const KVKK = () => {
  const navigate = useNavigate();

  return (
    <div className="kvkk-page">
      <Navbar />
      
      <main className="kvkk-main-content">
        <div className="kvkk-ambient-light"></div>
        
        <div className="container" style={{ position: 'relative', zIndex: 10 }}>
          {/* Back Button */}
          <motion.button
            className="kvkk-back-btn"
            onClick={() => navigate(-1)}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <ArrowLeft size={18} />
            <span>Geri Dön</span>
          </motion.button>

          {/* Content Card */}
          <motion.div
            className="kvkk-card"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.23, 1, 0.32, 1] }}
          >
            <header className="kvkk-header">
              <div className="kvkk-icon-wrapper">
                <Shield size={32} />
              </div>
              <h1 className="kvkk-title">KVKK Aydınlatma Metni</h1>
              <p className="kvkk-subtitle">Kapaklı Aydınlatma Metni ve Veri Politikası</p>
            </header>

            <div className="kvkk-body">
              <section className="kvkk-section">
                <div className="kvkk-section-header">
                  <div className="kvkk-badge">Bölüm 2</div>
                  <h3>2. Kişisel Veriler ve Verilerin İşlenme Amacı ve Hukuki Sebep</h3>
                </div>
                <p>Kanun uyarınca, veri sorumlusu Şirket olarak şahsınıza ait olan kişisel verilerinizden;</p>
                <ul className="kvkk-list">
                  <li><FileText size={14} /> Ad</li>
                  <li><FileText size={14} /> Soyad</li>
                  <li><FileText size={14} /> E-posta Adresi</li>
                  <li><FileText size={14} /> Cep Telefonu</li>
                </ul>
                <p>
                  bilgilerinizi işlemeyi talep ediyoruz. Ad, Soyadı, e-posta ve cep telefonu veriniz; 
                  sizinle iletişime geçilmesi, talep ve şikâyet mesajlarınızın değerlendirilmesi amaçları 
                  ile Kanun’un 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartlarına uygun ve 
                  yukarıda verilen amaçlarla sınırlı olarak işlenecektir.
                </p>
              </section>

              <section className="kvkk-section">
                <div className="kvkk-section-header">
                  <div className="kvkk-badge">Bölüm 3</div>
                  <h3>3. Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği</h3>
                </div>
                <p>
                  Kanun’un 8. maddesine uygun olarak kişisel verileriniz; İşbu Aydınlatma Metni’nin 
                  2. maddesinde yer alan amaçlarla; Yurt içindeki kanunen yetkili kamu resmi kurum ve 
                  kuruluşları, hizmet sağlayıcı firmalar ve yetkilileri, çağrı merkezi hizmet sunucuları, 
                  tedarikçiler ve destek hizmeti sağlayıcılar ve iş ortakları ile paylaşılabilecektir. 
                  Kişisel verilerinizin yurtdışına aktarılması söz konusu değildir.
                </p>
              </section>

              <section className="kvkk-section">
                <div className="kvkk-section-header">
                  <div className="kvkk-badge">Bölüm 4</div>
                  <h3>4. Kişisel Verilerin Toplanma Yöntemi</h3>
                </div>
                <p>
                  Kişisel verileriniz internet adresimizde yer alan sayfadan, tarafınızca yapılan 
                  başvuru vasıtasıyla toplanmaktadır.
                </p>
              </section>

              <section className="kvkk-section">
                <div className="kvkk-section-header">
                  <div className="kvkk-badge">Bölüm 6</div>
                  <h3>6. Kanun’un 11. Maddesinde Sayılan Diğer Haklar</h3>
                </div>
                <p>İlgili Kişi olarak, Kanun’un 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
                <div className="kvkk-rights-grid">
                  <div className="kvkk-right-item">
                    <Info size={16} />
                    <span>Kişisel verisinin işlenip işlenmediğini öğrenme</span>
                  </div>
                  <div className="kvkk-right-item">
                    <Info size={16} />
                    <span>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme</span>
                  </div>
                  <div className="kvkk-right-item">
                    <Info size={16} />
                    <span>Kişisel verilerin işlenme amacını ve uygun kullanılıp kullanılmadığını öğrenme</span>
                  </div>
                  <div className="kvkk-right-item">
                    <Info size={16} />
                    <span>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</span>
                  </div>
                  <div className="kvkk-right-item">
                    <Info size={16} />
                    <span>Eksik veya yanlış işlenmişse düzeltilmesini isteme</span>
                  </div>
                  <div className="kvkk-right-item">
                    <Info size={16} />
                    <span>Sebeplerin ortadan kalkması hâlinde silinmesini veya yok edilmesini isteme</span>
                  </div>
                  <div className="kvkk-right-item">
                    <Info size={16} />
                    <span>Otomatik sistemlerle analiz neticesinde aleyhe bir sonuca itiraz etme</span>
                  </div>
                  <div className="kvkk-right-item">
                    <Info size={16} />
                    <span>Kanuna aykırı işleme sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme</span>
                  </div>
                </div>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default KVKK;
